import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { getString } from 'script/dateutil'

import { Box, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Typography, Avatar, Link, Autocomplete, TextField, Card, CardContent } from '@mui/material'

import { Season } from 'model/Season'
import { Ranking as RankingModel } from 'model/Ranking'

import * as seasonRepository from 'repository/SeasonRepository'
import * as rankingRepository from 'repository/RankingRepository'

import { User } from 'model/User'

type Props = {
  user: User
}
export default function Ranking(props: Props) {

  const [seasons, setSeasons] = useState<Season[]>([])
  const [season, setSeason] = useState<Season | null>(null)
  useEffect(() => {
    seasonRepository
      .listFromCache(undefined, [{ key: 'end_time', condition: 'desc' }])
      .then(it => {
        const target = it.filter(_it => _it.start_time <= new Date().getTime())
        setSeasons(target)
        setSeason(target[0])
      })
    }, [])

  const [ranking, setRanking] = useState<RankingModel | null>(null)
  useEffect(() => {
    if (!season) return
    rankingRepository.listFromCache(season).then(it => setRanking(it))
  }, [season])

  const navigate = useNavigate()

  function getUpdateDate(): string {
    if (!ranking) return ''
    const datestr = getString(new Date(ranking.update_time))
    return `集計日時: ${datestr.slice(5, 16)}`
  }

  return (
    <Card variant='outlined'>
      <CardContent>
        <Autocomplete
          options={seasons!}
          getOptionLabel={op => op.name}
          isOptionEqualToValue={(op, val) => op.id === val.id}
          renderInput={(params) =>
            <TextField
              {...params}
              variant='standard'
              required
            />}
          value={season}
          onChange={(e, v) => setSeason(v)}
        />
        <Typography
          variant='body2'
          color='text.secondary'
          sx={{mt: 1}}
        >
          {getUpdateDate()}
        </Typography>

        <TableContainer sx={{mt: 2}}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>順位</TableCell>
                <TableCell>ユーザー</TableCell>
                <TableCell>レート</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {ranking &&
                ranking.users.map((user, i) => (
                  <React.Fragment key={user.uuid}>
                    <TableRow key={user.uuid}>
                      <TableCell>{user.rank}位</TableCell>
                      <TableCell
                      >
                        <Box
                        sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
                        >
                          <Avatar
                            variant='rounded'
                            src={user.profile_image_url}
                            sx={{mr: 0.5}}
                          />
                          <Link
                            onClick={() => navigate(`/mypage?id=${user.uuid}`)}
                            sx={{textDecoration: 'none', cursor: 'pointer'}}
                          >
                            {user.name}
                          </Link>
                        </Box>
                      </TableCell>
                      <TableCell>{user.rate}</TableCell>
                    </TableRow>
                  </React.Fragment>
                ))
              }
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  )
}